module.exports = __webpack_public_path__ + "static/media/blogpost4.e59194af.jpg";